export const NEW_LAYOUT_LIST = [
  "Contacts-CRM/view",
  "Contacts-CRM/contact-profile-overview",
  "Contacts-CRM/contact-profile-edit",
  "Contacts-CRM/add",
  "home/Change-Password",
  "home/Properties-CRM/view",
  "home/Contacts-CRM/merge",
  "Properties-CRM/property-profile-overview",
  "/developers/view",
  "/rotation-criteria/view",
  "/rotation-criteria/add-criteria"
];
